import { createEvent, createStore } from 'effector';

const $$weakPassword = {
    modalClosed: createEvent(),
    $changeRequired: createStore<boolean>(false),
};

export default $$weakPassword;
